import jane from '../assets/img/stills/jane/20161208-BALLOON1384_0022122.jpg';
import { Video } from './Video';

export const demoReel = new Video({
  vimeoID: '263986108/ee6df62f20',
  name: 'Demo Reel',
  thumbnail: jane,
});
